import { addToChainAfter, addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateAccount } from "@insite/client-framework/Services/AccountService";
import setLanguage from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import { CallUpdateAccount, chain, ExecuteOnSuccessCallback, GetCurrentAccount, LoadCurrentAccount, SetInitialValues } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import { getAccountSettingsState } from "@store/Store/Pages/AccountSettings/AccountSettingsSelectors";
import setIsLoading from "@store/Store/Pages/AccountSettings/Handlers/SetIsLoading";

addToChainAfter(chain, GetCurrentAccount, props => {
    const accountSettings = getAccountSettingsState(props.getState());
    const account = accountSettings.editingAccount;
    const preferredDefaultLanguage = accountSettings.preferredDefaultLanguage;

    if (!account) {
        throw new Error("Could not retrieve custom account data from state.");
    }

    props.account = { ...props.account, ...account,
        properties: {
            ...props.account.properties,
            ...account.properties,
            ...(preferredDefaultLanguage?{preferredDefaultLanguage}:null),
        }
    };
});

replaceInChain(chain, CallUpdateAccount, async props => {
    /* Poolcorp Custom Code */
    props.dispatch(setIsLoading(true));

    await updateAccount(props.apiParameter).then((result) => {
        props.apiResult = result;
        (props.parameter as any).onSuccess?.(props.apiResult);
    }, (error) => {
        (props as any).error = error;
        (props.parameter as any).onError?.(error);
    })
    /* Poolcorp Custom Code */
});

replaceInChain(chain, LoadCurrentAccount, props => {
    if (!(props as any).error) { LoadCurrentAccount(props); } // Poolcorp Custom Code
});

replaceInChain(chain, SetInitialValues, props => {
    if ((props as any).error) { SetInitialValues(props); } // Poolcorp Custom Code
});

replaceInChain(chain, ExecuteOnSuccessCallback, props => {
    // Poolcorp Custom Code - onSuccess is called by default when there is no error, no need to call it manually here
    // Save preferredDefaultLanguage in session
    const accountSettings = getAccountSettingsState(props.getState());
    const preferredDefaultLanguage = accountSettings.preferredDefaultLanguage;

    if (preferredDefaultLanguage) {
        props.dispatch(setLanguage({ languageId: preferredDefaultLanguage }));
    }
    // Poolcorp Custom Code
});

addToEndOfChain(chain, props => {
    props.dispatch(setIsLoading(false));
});
